export const data = {
  destin: [
    {
      month: 'Jan',
      price: 170,
    },
    {
      month: 'Feb',
      price: 236,
    },
    {
      month: 'Mar',
      price: 246,
    },
    {
      month: 'Apr',
      price: 262,
    },
    {
      month: 'May',
      price: 342,
    },
    {
      month: 'Jun',
      price: 354,
    },
    {
      month: 'Jul',
      price: 252,
    },
    {
      month: 'Aug',
      price: 206,
    },
    {
      month: 'Sep',
      price: 195,
    },
    {
      month: 'Oct',
      price: 174,
    },
    {
      month: 'Nov',
      price: 176,
    },
    {
      month: 'Dec',
      price: 179,
    },
  ],
  sandestin: [
    {
      month: 'Jan',
      price: 171,
    },
    {
      month: 'Feb',
      price: 245,
    },
    {
      month: 'Mar',
      price: 230,
    },
    {
      month: 'Apr',
      price: 246,
    },
    {
      month: 'May',
      price: 308,
    },
    {
      month: 'Jun',
      price: 316,
    },
    {
      month: 'Jul',
      price: 236,
    },
    {
      month: 'Aug',
      price: 206,
    },
    {
      month: 'Sep',
      price: 190,
    },
    {
      month: 'Oct',
      price: 172,
    },
    {
      month: 'Nov',
      price: 175,
    },
    {
      month: 'Dec',
      price: 180,
    },
  ],
  'miramar-beach': [
    {
      month: 'Jan',
      price: 171,
    },
    {
      month: 'Feb',
      price: 245,
    },
    {
      month: 'Mar',
      price: 230,
    },
    {
      month: 'Apr',
      price: 246,
    },
    {
      month: 'May',
      price: 308,
    },
    {
      month: 'Jun',
      price: 316,
    },
    {
      month: 'Jul',
      price: 236,
    },
    {
      month: 'Aug',
      price: 206,
    },
    {
      month: 'Sep',
      price: 190,
    },
    {
      month: 'Oct',
      price: 172,
    },
    {
      month: 'Nov',
      price: 175,
    },
    {
      month: 'Dec',
      price: 180,
    },
  ],
  '30a': [
    {
      month: 'Jan',
      price: 202,
    },
    {
      month: 'Feb',
      price: 265,
    },
    {
      month: 'Mar',
      price: 272,
    },
    {
      month: 'Apr',
      price: 293,
    },
    {
      month: 'May',
      price: 377,
    },
    {
      month: 'Jun',
      price: 389,
    },
    {
      month: 'Jul',
      price: 289,
    },
    {
      month: 'Aug',
      price: 241,
    },
    {
      month: 'Sep',
      price: 231,
    },
    {
      month: 'Oct',
      price: 214,
    },
    {
      month: 'Nov',
      price: 231,
    },
    {
      month: 'Dec',
      price: 206,
    },
  ],
  'fort-walton-beach': [
    {
      month: 'Jan',
      price: 168,
    },
    {
      month: 'Feb',
      price: 233,
    },
    {
      month: 'Mar',
      price: 221,
    },
    {
      month: 'Apr',
      price: 258,
    },
    {
      month: 'May',
      price: 339,
    },
    {
      month: 'Jun',
      price: 348,
    },
    {
      month: 'Jul',
      price: 248,
    },
    {
      month: 'Aug',
      price: 202,
    },
    {
      month: 'Sep',
      price: 194,
    },
    {
      month: 'Oct',
      price: 174,
    },
    {
      month: 'Nov',
      price: 174,
    },
    {
      month: 'Dec',
      price: 177,
    },
  ],
};
